import { ComponentTemplate, MetadataTemplate } from ".";
import { Requirement, RequirementItem } from "../requirements";

export class SectionTemplate extends ComponentTemplate {
	public static readonly $type: string = "SectionTemplate";
	public readonly $type: string = SectionTemplate.$type;

	public dataTemplate!: MetadataTemplate;
	public areRequirementsEnforced!: boolean;
	public templateRequirementList!: Array<RequirementItem<ComponentTemplate>>;
	public requirements!: Array<Requirement>;
}
